import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { configuracion } from 'src/configuracion';

/**
 * Adapter de upload para CKEditor 5.
 *
 * Función para insertar una imagen en el editor, CKEditor delega la subida
 * en este adapter. Se envia al endpoint `POST /api/helps/upload-image` y se obtiene la URL
 * pública del blob almacenado en Azure Blob Storage.
 *
 */
export class CkUploadAdapter {
  private readonly endpoint = `${configuracion.servidor_api}/api/helps/upload-image`;

  constructor(
    private loader: any,
    private http: HttpClient,
  ) {}

  /**
   * CKEditor invoca este método para subir la imagen.
   * @returns - URL de la imagen subida
   * @throws - Error si no se recibe la URL de la imagen
   */
  async upload(): Promise<{ default: string }> {
    try {
      const file: File = await this.loader.file;

      const formData = new FormData();
      formData.append('file', file, file.name);

      const response = await firstValueFrom(
        this.http.post<{ url: string }>(this.endpoint, formData),
      );

      if (!response?.url) {
        throw new Error('No se recibió la URL de la imagen');
      }

      return { default: response.url };
    } catch (err: unknown) {
      const httpErr = err as { error?: { message?: string }; message?: string };
      const message =
        httpErr?.error?.message ||
        httpErr?.message ||
        'Error al subir la imagen';
      throw new Error(message);
    }
  }

  /**
   * CKEditor invoca este método cuando se cancela la subida.
   */
  abort(): void {
    // no-op
  }
}
